import { wordService } from "../services/wordService";

export const applyFigure = () => wordService.applySemanticTag({ type: "figure" });
export const applyFigureCaption = async () =>
  wordService.applySemanticTag({ type: "figure_caption", metadata: { parent: await wordService.latestSemanticId("figure") } });
